let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2Rwew")).then(() => parcelRequire('6WKkC'));